import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionEquityLessThen extends AbstractConditionDescriptionComponent {

    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionEquityLessThen, require('./ConditionEquityLessThen.html'))

}